<template>
  <div class="book-box">
    <div class="title">
      <span :class="type === 1 ? 'active' : ''" @click="changeTab(1)"
        >主管期刊</span
      >
      <span :class="type === 2 ? 'active' : ''" @click="changeTab(2)"
        >主办期刊</span
      >
      <span :class="type === 3 ? 'active' : ''" @click="changeTab(3)"
        >出版期刊</span
      >
    </div>
    <div class="book-content" v-if="orgPeriodical[type] && orgPeriodical[type].length > 0">
      <div class="item" v-for="item in list" :key="item.id">
        <div class="item-img">
          <img :src="`${$global.imgUrl}${item.coverImg}`" alt="">
        </div>
        <div class="item-name">
          {{item.name}}
        </div>
      </div>
      <div class="more" v-if="isMore && orgPeriodical[type].length > 7" @click="isMore = false">展开全部</div>
    </div>
    <div class="empty" v-else>暂无期刊</div>
  </div>
</template>

<script>
export default {
  name: "book",
  props: ["orgPeriodical"],
  data() {
    return {
      type: 1,
      isMore: true,
    };
  },
  computed: {
    list() {
      let arr = [];
      if (this.isMore) {
        arr = [...this.orgPeriodical[this.type]].splice(0, 7);
      } else {
        arr = [...this.orgPeriodical[this.type]];
      }
      return arr;
    },
  },
  methods: {
    changeTab(type) {
      this.type = type
      this.isMore = true
      console.log(type);
    },
  },
};
</script>

<style lang="scss" scoped>
.book-box {
  .title {
    font-size: 22px;
    color: #666;
    .active {
      color: #1d52eb;
    }
    span {
      margin-right: 30px;
      cursor: pointer;
    }
  }
  
  .empty {
    padding: 60px 0;
    text-align: center;
    font-size: 16px;
    color: #666666;
  }

  .book-content {
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-top: 40px;
      margin-right: 27px;
      width: 135px;
      .item-img {
        width: 135px;
        height: 180px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item-name {
        font-size: 14px;
        color: #434343;
        text-align: center;
      }
    }
    .more {
      margin: 30px auto 0;
      width: 200px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border: 1px solid #a3cbe7;
      border-radius: 10px;
      font-size: 16px;
      color: #333;
      cursor: pointer;
    }
  }
}
</style>
